export const COMPANY_LINK_FORM_SCHEMA_TRANS_PATH =
  'EDIT_COMPANY_LINK_FORM.FORM_SCHEMA';
